import React, { Component } from 'react';

import TextInput from "../../../component/input/TextInput";
import SingleButton from "../../../component/button/SingleButton";
import SelectList from "../../../component/input/SelectList";
import JoinHeader from "../component/JoinHeader";
import Loading from "../../../component/loading/Loading";
import PhoneAuthInputComp from "../component/PhoneAuthInputComp";
import SyncLoginProcess from "../component/SyncLoginProcess";
import CategorySelectComp from "../../selfmessage/message/component/CategorySelectComp";
import Modal from "../../../component/modal/ModalTemplate";
import DaumPostcode from "react-daum-postcode";
import Footer from "../../../component/layout/Footer";

import loginPageCss from "../css/loginPage.module.css";
import "../css/loginPage.css"

import * as apiUtil from '../../../util/apiUtil';
import { getAdSrcForSubmit } from '../../../util/adAttribution';

import * as registerInfoAction from '../store/registerInfo';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// import {Tooltip} from "@mui/material";
import {aesDecrypt, aesEncrypt} from "../../../util/aes256";

const mailList = [
    { label: 'gmail.com', value: 'gmail.com' },
    { label: 'naver.com', value: 'naver.com' },
    { label: 'daum.net', value: 'daum.net' },
    { label: 'nate.com', value: 'nate.com'}
];

/* API 사용 호스팅 사 */
/* 아래 배열에 속한 호스팅사만 아이디로 사용자 정보 조회 가능하도록 구성 */
const oAuthHostList = ['CAFE24'];

class JoinInfoContainer extends Component {
    constructor(props) {
        super(props);

        this.setLoading = this.setLoading.bind(this);
        this.ajaxOAuthProfile = this.ajaxOAuthProfile.bind(this);
        this.ajaxGetCafe24UserInfo = this.ajaxGetCafe24UserInfo.bind(this);

        this.movePage = this.movePage.bind(this);
        this.ajaxRegisterInfo = this.ajaxRegisterInfo.bind(this);

        this.setValue = this.setValue.bind(this);
        this.setEmailValue = this.setEmailValue.bind(this);

        /*아이디 중복 체크*/
        this.checkIdDuplicate = this.checkIdDuplicate.bind(this);
        /*휴대폰 검증*/
        this.handlePhoneVerify = this.handlePhoneVerify.bind(this);
        /*주소 찾기*/
        this.onPostOpen = this.onPostOpen.bind(this);
        this.handleComplete = this.handleComplete.bind(this);
        /*파일 검수*/
        this.setFile = this.setFile.bind(this);

        this.setRivalCompanyUrl = this.setRivalCompanyUrl.bind(this);
        this.addRivalCompanyUrl = this.addRivalCompanyUrl.bind(this);
        this.subRivalCompanyUrl = this.subRivalCompanyUrl.bind(this);

        /*validate*/
        this.validate = this.validate.bind(this);

        this.state = {
            loading: false,

            addressModalOpen : false,
        };
    }

    shouldComponentUpdate(nextProps, nextState, nextContext){
        return (
            this.state.loading !== nextState.loading
            || this.state.addressModalOpen !== nextState.addressModalOpen
            || this.props.checkInfo !== nextProps.checkInfo
            || this.props.registerInfo !== nextProps.registerInfo
            || this.props.registerInfo.hostType !== nextProps.registerInfo.hostType
            || this.props.rivalCompanyUrl !== nextProps.rivalCompanyUrl
            || this.props.rivalCompanyUrls !== nextProps.rivalCompanyUrls
        )
    }

    async componentDidMount() {
        const { jToken } = this.props;
        const { hToken, hstate } = this.props;
        const { RegisterInfoAction } = this.props;

        if (hstate && hstate.hostType === 'C') {
            await RegisterInfoAction.setHostType('CAFE24');
            if (hstate.hostId) {
                await RegisterInfoAction.setHostId(hstate.hostId);
            }
        } else if (hstate && hstate.hostType === 'S') {
            await RegisterInfoAction.setHostType('SOLAPI');
        } else if (hstate && hstate.hostType === 'M') {
            await RegisterInfoAction.setHostType('MAKESHOP');
        } else if (hstate && hstate.hostType === 'MP') {
            await RegisterInfoAction.setHostType('MESSAGE_PANG');
        } else if (hstate && hstate.hostType === 'CHERO') {
            await RegisterInfoAction.setHostType('CHERO');
        } else if (hstate && hstate.hostType === 'A') {
            await RegisterInfoAction.setHostType('ACADEMY');
        } else if (hstate && hstate.hostType === 'STORETALK') {
            await RegisterInfoAction.setHostType('STORETALK');
        } else {
            await RegisterInfoAction.setHostType('');
        }

        /* after hosting redirect */
        if (hstate && hToken) {
            switch (hstate.hostType) {
                case "C":
                    this.ajaxGetCafe24UserInfo(hstate, hToken);
                    break;
                case "M":
                case "MP":
                case "CHERO":
                    break;
                default:
                    break;
            }
        }
        else {
            apiUtil.asyncRequest({
                setLoading: this.setLoading,
                url: `/api/auth/agree/check`,
                method: apiUtil.requestMethod.POST,
                redirect_url: "/",
                data: {
                    tokenJoin: jToken,
                },
                success: (result) => {
                    this.ajaxOAuthProfile()
                }
            });
        }
    }

    ajaxOAuthProfile() {
        const { RegisterInfoAction } = this.props;
        const { oState, tMms, tMail, tKakao } = this.props;

        if (oState) {
            const oAuthInfo = JSON.parse(aesDecrypt(oState));

            apiUtil.asyncRequest({
                setLoading: this.setLoading,
                url: `/api/auth/${oAuthInfo.oAuthType.toLowerCase()}/profile?token=${oAuthInfo.accessToken}`,
                method: apiUtil.requestMethod.POST,
                redirect_url: "/",
                data: {},
                success: (result) => {
                    RegisterInfoAction.setBasicUserInfo({
                        useSync:  'Y',
                        syncType: oAuthInfo.oAuthType,
                        siteid:   result.siteid,
                        password: result.password,
                        email:    result.email,
                        phone:    result.phone,
                        name:     result.name,
                    });
                    RegisterInfoAction.checkForBasicUser({
                        idDuplicated: true,
                        phoneAuth:    true,
                        emailValid:   true,
                    });
                }
            }).then(()=>{
                setTimeout(() => {
                    // console.log(this.props.registerInfo);
                }, 1000);

            });
        }

        RegisterInfoAction.setAgreeRecvMms(tMms);
        RegisterInfoAction.setAgreeRecvMail(tMail);
        RegisterInfoAction.setAgreeRecvKakao(tKakao === 'Y' ? 'Y' : 'N');
    }
    ajaxGetCafe24UserInfo(hstate, hToken) {
        const { encryptedHstate } = this.props;
        const { RegisterInfoAction } = this.props;

        apiUtil.asyncRequest({
            url: `/api/bizchat/user/cafe24/mallId/${hstate.hostId}/store/read?token=${hToken}`,
            method: apiUtil.requestMethod.POST,
            redirect_url: `/account/login?hstate=${encryptedHstate}`,
            success: (result) => {
                RegisterInfoAction.setBasicUserInfo({
                    useSync:  result.useSync,
                    syncType: result.syncType,
                    siteid:   result.siteid,
                    password: result.password,
                    email:    result.email,
                    phone:    result.phone,
                    name:     result.name,
                });
                RegisterInfoAction.setHostBusinessInfo({
                    hostType:     result.hostType,
                    hostId:       result.hostId,
                    companyName:  result.comName,
                    CEO:          result.comPresidentName,
                    bussinessNum: result.comRegistNo,
                    postNum:      result.comZipcode,
                    basicAddr:    result.comAddress1,
                    detailAddr:   result.comAddress2,
                });
                RegisterInfoAction.checkForBasicUser({
                    idDuplicated: result.idDuplicated,
                    phoneAuth:    result.phoneAuth,
                    emailValid:   result.emailValid,
                });
                RegisterInfoAction.setAgreeRecvMms(result.agreeRecvMms);
                RegisterInfoAction.setAgreeRecvMail(result.agreeRecvMail);
            }
        });
    }

    setLoading(loading) {
        this.setState({ loading: loading });
    }

    movePage(page) {
        const { encryptedHstate } = this.props;

        if(page === 'agree') {
            let url = "/register/" + page;
            if(encryptedHstate) url += `?hstate=${encryptedHstate}`;
            window.location.href = url;
        }
        if(page === 'complete') {
            window.location.href = "/register/" + page;
        }
    }

    setValue(id, value) {
        const { RegisterInfoAction } = this.props;

        switch (id) {
            case "siteid" :
                RegisterInfoAction.setSiteId(value);
                break;
            case "password":
                RegisterInfoAction.setPassword(value);
                break;
            case "passwordCheck":
                RegisterInfoAction.setPasswordCheck(value);
                break;
            case "phone":
                RegisterInfoAction.setPhone(value);
                break;
            case "name":
                RegisterInfoAction.setName(value);
                break;
            case "email":
                RegisterInfoAction.setEmail(value);
                break;
            case "companyName":
                RegisterInfoAction.setCompanyName(value);
                break;
            case "CEO":
                RegisterInfoAction.setCeo(value);
                break;
            case "bussinessNum":
                RegisterInfoAction.setBussinessNum(value
                    .replace(/[^0-9]/g, '')
                    .replace(/^(\d{1,3})(\d{0,2})(\d{0,5}).*$/, '$1-$2-$3')
                    .replace(/^-/, '')
                    .replace(/-$/, '')
                    .replace(/-$/, ''));
                break;
            case "postNum":
                RegisterInfoAction.setPostNum(value);
                break;
            case "basicAddr":
                RegisterInfoAction.setBasicAddr(value);
                break;
            case "detailAddr":
                RegisterInfoAction.setDetailAddr(value);
                break;
            case "businessFile":
                RegisterInfoAction.setBussinessFile(value);
                break;
            case "main":
                RegisterInfoAction.setMainCateID(value);
                break;
            case "mid":
                RegisterInfoAction.setMidCateID(value);
                break;
            case "sub":
                RegisterInfoAction.setSubCateID(value);
                break;
            case "hostType":
                RegisterInfoAction.setHostType(value);
                break;
            case "hostId":
                RegisterInfoAction.setHostId(value);
                break;
            default:
                break;
        }
    }

    checkIdDuplicate() {
        const { RegisterInfoAction, registerInfo } = this.props;

        const reg = /^(?=.*[A-Za-z])(?=.*[0-9]).{6,20}$/;
        if (! reg.test(registerInfo.siteid)) {
            alert("아이디는 영문 숫자 조합 6~20자 까지만 가능하며 영문으로 시작해야합니다!");
            return ;
        }

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/duplicate/" + registerInfo.siteid,
            method: apiUtil.requestMethod.POST,
            isFile: false,
            data: {},
            success: (result) => {
                if (result) {
                    alert("이미 존재하는 아이디 입니다.");
                } else {
                    if (window.confirm("사용 가능한 아이디 입니다! 사용하시겠습니까?")) {
                        RegisterInfoAction.checkSiteIdDuplicate(true);
                    } else {
                        alert("사용하고 싶은 아이디를 다시 설정하여 중복확인 버튼을 눌러주세요!")
                    }
                }
            }
        })
    }

    handlePhoneVerify (data) {
        this.setValue("name", data.name);
        this.setValue("phone", data.phone);

        const { RegisterInfoAction } = this.props;
        RegisterInfoAction.setTid(data.tid);
        RegisterInfoAction.checkPhoneAuth(true);

        alert("휴대전화 인증이 완료되었습니다!");
    }

    setEmailValue(id, value) {
        const { RegisterInfoAction, registerInfo } = this.props;
        const { emailFront, emailBack } = registerInfo;

        let fullEmail = '';
        switch(id) {
            case "emailFront":
                RegisterInfoAction.setEmailFront(value);
                fullEmail = value + '@' + emailBack;
                break;
            case "emailBack":
                RegisterInfoAction.setEmailBack(value);
                RegisterInfoAction.setEmailSelect('');
                fullEmail = emailFront + '@' + value;
                break;
            case "emailSelect":
                RegisterInfoAction.setEmailBack(value);
                RegisterInfoAction.setEmailSelect(value);
                fullEmail = emailFront + '@' + value;
                break;
        }

        const re = /^[\w.-]+@[\w.-]+\.[A-Za-z]{2,}$/;
        const isEmailValid = re.test(String(fullEmail).toLowerCase());

        this.setValue("email", fullEmail);

        RegisterInfoAction.checkValidEmail(isEmailValid);
    }

    onPostOpen() {
        this.setState({ addressModalOpen: true });
    }

    handleComplete(data) {
        this.setValue("basicAddr", data.address);
        this.setValue("postNum", data.zonecode);

        this.setState({ addressModalOpen: false });
    }

    setFile(e) {
        // 파일을 첨부 하였는지를 확인하는 if문
        if (e.target.files && e.target.files[0]) {
            let maxSize = 20 * 1024 * 1024;
            let fileSize = e.target.files[0].size;

            if (fileSize > maxSize) {
                alert('파일은 20MB 이내의 사이즈만 됩니다!!');
                e.target.value = null;
            } else if (e.target.files.length > 1) {
                alert('파일은 하나만 올려주세요!');
                e.target.value = null;
            } else {
                this.setValue("businessFile", e.target.files[0]);
            }
        }else {
            this.setValue("businessFile", null);
        }
    }

    setRivalCompanyUrl(id, value) {
        const { RegisterInfoAction } = this.props;

        switch(id) {
            case "rivalCompanyUrl":
                RegisterInfoAction.setRivalCompanyUrl(value);
                break;
        }
    }

    addRivalCompanyUrl() {
        const { RegisterInfoAction, rivalCompanyUrls, rivalCompanyUrl } = this.props;
        const newUrlArray = rivalCompanyUrls.concat(rivalCompanyUrl);

        if (newUrlArray.length > 10) {
            alert("경쟁업체 URL은 최대 10개 까지 입력 가능합니다.")
            return;
        }

        RegisterInfoAction.setRivalCompanyUrls(newUrlArray);
    }

    subRivalCompanyUrl(rivalCompanyUrl) {
        const { RegisterInfoAction, rivalCompanyUrls } = this.props;
        const newUrlArray = [];
        rivalCompanyUrls.map((item, index) => {
            if (item !== rivalCompanyUrl) {
                newUrlArray.push(item);
            }
        })

        RegisterInfoAction.setRivalCompanyUrls(newUrlArray);
    }

    ajaxRegisterInfo() {
        let result = this.validate();
        if (result !== 'ok') {
            alert(result);
            return;
        }

        if (! window.confirm('입력한 정보로 회원가입 하시겠습니까?')) {
            return;
        }

        const { registerInfo, businessFile, rivalCompanyUrls } = this.props;

        if (businessFile === null) {
            alert("필수 값이 누락되었습니다. (사업자 등록증)");
            return;
        }

        if (registerInfo.mainCategoryId === '' || registerInfo.midCategoryId === '' || registerInfo.subCategoryId === '') {
            alert("필수 값이 누락 되었습니다. (타겟팅 희망 카테고리)");
            return;
        }

        const adSrc = getAdSrcForSubmit();
        const sessionId = window.sessionStorage.getItem('sessionId') === null ?
            crypto.randomUUID() : window.sessionStorage.getItem('sessionId');

        let data = new FormData();

        data.append("useSync", registerInfo.useSync === 'Y');
        data.append("syncType", registerInfo.syncType);
        data.append("hostId", registerInfo.hostId);
        data.append("hostType", registerInfo.hostType);
        data.append("siteid", aesEncrypt(registerInfo.siteid));
        data.append("password", aesEncrypt(registerInfo.password));
        data.append("phone", registerInfo.phone);
        // data.append("phone", '01021145520');
        data.append("tid", registerInfo.tid);
        data.append("name", registerInfo.name);
        data.append("email", registerInfo.email);
        data.append("comName", registerInfo.companyName);
        data.append("comPresidentName", registerInfo.CEO);
        data.append("comRegistNo", registerInfo.bussinessNum);
        data.append("comRegistImg", businessFile);
        data.append("comZipcode", registerInfo.postNum);
        data.append("comAddress1", registerInfo.basicAddr);
        data.append("comAddress2", registerInfo.detailAddr);
        data.append("mainCategoryId", registerInfo.mainCategoryId);
        data.append("midCategoryId", registerInfo.midCategoryId);
        data.append("subCategoryId", registerInfo.subCategoryId);
        data.append("agreeRecvMms", registerInfo.agreeRecvMms);
        data.append("agreeRecvMail", registerInfo.agreeRecvMail);
        data.append("agreeRecvKakao", registerInfo.agreeRecvKakao === 'Y' ? 'Y' : 'N');
        data.append("rivalCompanyUrl", rivalCompanyUrls);
        data.append("adSource", adSrc);
        data.append("sessionId", sessionId);

        apiUtil.asyncRequest({
            setLoading: this.setLoading,
            url: "/api/bizchat/user/signup",
            method: apiUtil.requestMethod.POST,
            isFile: true,
            data: data,
            success: (result) => {
                // const { RegisterAction } = this.props;
                if(result && typeof result === 'object') {
                    alert("회원가입이 완료되었습니다!");
                    this.movePage('complete');
                }
            }
        });
    }

    validate() {
        const { checkInfo } = this.props;

        if (false) {
            return "카테고리 선택은 필수입니다! 3가지 옵션을 모두 선택해주세요!"
        } else if (!checkInfo.idDuplicated) {
            return "아이디 중복 확인을 눌러주세요!";
        } else if (!checkInfo.phoneAuth) {
            return "휴대폰 인증은 필수 입니다! 휴대폰 인증 버튼을 눌러주세요";
        } else if (!checkInfo.emailValid) {
            return "이메일은 필수 입력값입니다!";
        // } else if (!checkInfo.email) {
        //     return "이메일은 필수 입력값입니다!";
        // } else if (!checkInfo.name) {
        //     return "담당자 성명은 필수 입니다!";
        // } else if (!checkInfo.companyName) {
        //     return "회사 명은 필수 입니다!";
        // } else if (!checkInfo.address) {
        //     return "업체 주소는 필수 입니다! 검색을 통해 주소를 입력하고 상세주소를 작성해주세요";
        // } else if (!checkInfo.isFile) {
        //     return "사업자 등록증은 필수 입니다! 규격에 맞게 사진파일을 올려주세요!";
        // } else if (!checkInfo.BSNum) {
        //     return "사업자 번호는 필수 입니다!";
        }

        return "ok";
    }

    render() {
        const { loading, addressModalOpen } = this.state;
        const { encryptedHstate, checkInfo, registerInfo, rivalCompanyUrl, rivalCompanyUrls } = this.props;

        const { setValue, checkIdDuplicate, handlePhoneVerify, setEmailValue, setFile } = this;
        const { setRivalCompanyUrl, addRivalCompanyUrl, subRivalCompanyUrl } = this;
        const { movePage, ajaxRegisterInfo } = this;
        const { onPostOpen, handleComplete } = this;

        return (
            <>
                <JoinHeader
                    hstate={encryptedHstate}
                    joinStep={2}
                >
                    <Loading loading={loading}/>
                    <div className={`${loginPageCss["card"]} p-lg-5 card card-body form-group ${loginPageCss["form-group"]}`}>
                        {
                            registerInfo.useSync !== "Y" &&
                            <>
                                <div className={`${loginPageCss["d-flex"]} d-flex justify-content-between`}>
                                    <h1 className='fs-4 fw-bold mb-4'>담당자 정보</h1>
                                    <small className='text-danger fs-7'>*표시는 필수 입력항목입니다</small>
                                </div>

                                <div className='row align-items-center'>
                                    <div className="col-sm-3">
                                        <label htmlFor="siteid">아이디<span className='text-danger'>*</span></label>
                                    </div>
                                    <div className='col-sm-9 d-flex'>
                                        <TextInput
                                            className="form-control me-2"
                                            type="text"
                                            id="siteid"
                                            placeholder="아이디를 입력해주세요"
                                            value={registerInfo.siteid}
                                            readOnly={checkInfo.idDuplicated}
                                            onChange={setValue}
                                        />
                                        <SingleButton
                                            className="btn btn-outline-primary"
                                            label="중복 확인"
                                            handleClick={checkIdDuplicate}
                                            disabled={checkInfo.idDuplicated}
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center mt-3">
                                    <div className="col-sm-3">
                                        <label htmlFor="password">비밀번호<span className='text-danger'>*</span></label>
                                    </div>
                                    <div className="col-sm-9">
                                        <TextInput
                                            className={`${loginPageCss["form-control"]} form-control`}
                                            type="password"
                                            id="password"
                                            placeholder="비밀번호를 입력해주세요"
                                            value={registerInfo.password}
                                            onChange={setValue}
                                        />
                                    </div>
                                </div>
                                <div className="row align-items-center">
                                    <div className='col-sm-3'></div>
                                    <div className="col-sm-9">
                                        {
                                            registerInfo.password !== ''
                                            && (!/^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}|(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-]).{8,15}|(?=.*[0-9])(?=.*[!@#$%^*+=-]).{8,20}$/.test(registerInfo.password))
                                            && <small className={"d-block pt-1 text-danger"}>비밀번호 조건을 확인해주세요!</small>
                                        }
                                        <small className={`text-muted fs-7`}>8 ~ 20자 내로 영문 대/소문자, 숫자, 특수문자 중 2개 선택</small>
                                    </div>
                                </div>

                                <div className="row align-items-center">
                                    <div className='col-sm-3'>
                                        <label htmlFor="passwordCheck">비밀번호 확인<span className='text-danger'>*</span></label>
                                    </div>
                                    <div className='col-sm-9'>
                                        <TextInput
                                            className={`${loginPageCss["form-control"]} form-control`}
                                            type="password"
                                            id="passwordCheck"
                                            placeholder="비밀번호 재확인"
                                            value={registerInfo.passwordCheck}
                                            onChange={setValue}
                                        />
                                    </div>
                                </div>
                                <div className='row align-items-center'>
                                    <div className='col-sm-3'></div>
                                    <div className='col-sm-9'>
                                        {
                                            registerInfo.passwordCheck !== ''
                                            && registerInfo.password !== registerInfo.passwordCheck
                                            && <small className={"pt-1 d-block text-danger"}>비밀번호와 일치하지 않습니다!</small>
                                        }
                                        <small className={`text-muted fs-7`}>8 ~ 20자 내로 영문 대/소문자, 숫자, 특수문자 중 2개 선택</small>
                                    </div>
                                </div>

                                <PhoneAuthInputComp
                                    num={registerInfo.phone}
                                    handlePhoneVerify={handlePhoneVerify}
                                    setValue={setValue}
                                />

                                <div className='row align-items-center mt-3'>
                                    <div className='col-sm-3'>
                                        <label htmlFor="name">이름<span className='text-danger'>*</span></label>
                                    </div>
                                    <div className='col-sm-9'>
                                        <TextInput
                                            className={`${loginPageCss["form-control"]} form-control`}
                                            type="text"
                                            id="name"
                                            placeholder="이름을 입력해주세요"
                                            value={registerInfo.name}
                                            onChange={setValue}
                                        />
                                    </div>
                                </div>

                                <div className='row align-items-center mt-3'>
                                    <div className='col-sm-3'>
                                        <label htmlFor="emailFront">이메일<span className='text-danger'>*</span></label>
                                    </div>
                                    <div className='col-sm-9 d-flex'>
                                        <TextInput
                                            className={`${loginPageCss["form-control"]} form-control d-inline me-1`}
                                            type="text"
                                            id="emailFront"
                                            value={registerInfo.emailFront}
                                            onChange={setEmailValue}
                                        /> 
                                        <span>@</span>
                                        <TextInput
                                            className={`${loginPageCss["form-control"]} form-control d-inline mx-1`}
                                            type="text"
                                            id="emailBack"
                                            value={registerInfo.emailBack}
                                            onChange={setEmailValue}
                                        />
                                        <SelectList
                                            className={`${loginPageCss["form-select"]} form-select d-inline ms-1`}
                                            id="emailSelect"
                                            list={mailList}
                                            value={registerInfo.emailSelect}
                                            onChange={setEmailValue}
                                            defaultLabel="직접입력"
                                        />
                                    </div>
                                </div>
                                <hr className='my-5'></hr>
                            </>
                        }

                        <div className="d-flex justify-content-between">
                            <h1 className="fs-4 fw-bold mb-4">업체 정보</h1>
                            <small className="text-danger fs-7">*표시는 필수 입력항목입니다</small>
                        </div>
                        {
                            oAuthHostList.includes(registerInfo.hostType) &&
                            <SyncLoginProcess
                                registerInfo={registerInfo}
                                jToken={this.props.jToken}
                                setValue={setValue}
                                checkInfo={checkInfo}
                            />
                        }

                        <div className='row align-items-center mt-3'>
                            <div className='col-sm-3'>
                                <label htmlFor="companyName">회사명<span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-sm-9'>
                                <TextInput
                                    className={`${loginPageCss["form-control"]} form-control`}
                                    type="text"
                                    id="companyName"
                                    placeholder="회사명을 입력해주세요"
                                    value={registerInfo.companyName}
                                    onChange={setValue}
                                />
                            </div>
                        </div>

                        <div className='row align-items-center mt-3'>
                            <div className='col-sm-3'>
                                <label htmlFor="CEO">대표자명(선택)</label>
                            </div>
                            <div className='col-sm-9'>
                                <TextInput
                                    className={`${loginPageCss["form-control"]} form-control`}
                                    type="text"
                                    id="CEO"
                                    value={registerInfo.CEO}
                                    onChange={setValue}
                                />
                            </div>
                        </div>
                        <div className='row align-items-center mt-3'>
                            <div className='col-sm-3'>
                                <label htmlFor="bussinessNum">사업자 번호<span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-sm-9'>
                                <TextInput
                                    className={`${loginPageCss["form-control"]} form-control`}
                                    type="text"
                                    id="bussinessNum"
                                    value={registerInfo.bussinessNum}
                                    placeholder="- 없이 입력"
                                    onChange={setValue}
                                />
                            </div>
                        </div>

                        <div className='row mt-3'>
                            <div className='col-sm-3'>
                                {/*<Tooltip title={*/}
                                {/*    <div>*/}
                                {/*        <p className="mb-0">*/}
                                {/*            선택하신 카테고리로 자동으로 타겟 추출이 진행됩니다.<br/>*/}
                                {/*            (마이페이지에서 변경 가능)<br/>*/}
                                {/*            해당하는 카테고리가 없으시면 tf@biztalk.co.kr로<br/>*/}
                                {/*            추가 요청 메일 전송 부탁드립니다.*/}
                                {/*        </p>*/}
                                {/*    </div>}>*/}
                                <label htmlFor="cateLV1" className={"text"}>업종
                                    <span
                                        className='text-danger'> *</span>
                                    {/*<span*/}
                                    {/*    className="mx-0 material-symbols-rounded fs-5 text-primary ps-2">info</span>*/}
                                    <br/><span className="text-center">카테고리</span></label>
                                {/*</Tooltip>*/}
                            </div>
                            <div className='col-sm-9'>
                                <CategorySelectComp
                                    setCateValue={setValue}
                                    main={registerInfo.mainCategoryId}
                                    mid={registerInfo.midCategoryId}
                                    sub={registerInfo.subCategoryId}
                                />
                            </div>
                        </div>

                        <div className='row align-items-center mt-3'>
                            <div className='col-sm-3'>
                                <label htmlFor="postNum">주소<span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-sm-9 d-flex'>
                                <TextInput
                                    className={`${loginPageCss["form-control"]} form-control me-2`}
                                    type="text"
                                    id="postNum"
                                    value={registerInfo.postNum}
                                    placeholder="우편번호"
                                    readOnly={true}
                                />
                                <SingleButton
                                    className={`${loginPageCss["btn"]} btn btn-outline-primary`}
                                    label="검색"
                                    handleClick={onPostOpen}
                                />
                            </div>
                        </div>
                        <div className='row align-items-center mt-2'>
                            <div className='col-sm-3'></div>
                            <div className='col-sm-9'>
                                <TextInput
                                    className={`${loginPageCss["form-control"]} form-control`}
                                    type="text"
                                    id="basicAddr"
                                    value={registerInfo.basicAddr}
                                    placeholder="기본 주소를 검색해주세요"
                                    readOnly={true}
                                />
                            </div>
                        </div>
                        <div className='row align-items-center mt-2'>
                            <div className='col-sm-3'></div>
                            <div className='col-sm-9'>
                                <TextInput
                                    className={`${loginPageCss["form-control"]} form-control`}
                                    type="text"
                                    id="detailAddr"
                                    value={registerInfo.detailAddr}
                                    placeholder="상세 주소를 입력해주세요"
                                    onChange={setValue}
                                />
                            </div>
                        </div>

                        <div className='row align-items-center mt-3'>
                            <div className='col-sm-3'>
                                <label htmlFor="">사업자 등록증 <span className='text-danger'>*</span></label>
                            </div>
                            <div className='col-sm-9'>
                                <input
                                    className={`${loginPageCss["form-control"]} form-control`}
                                    type="file"
                                    id="businessFile"
                                    name="businessFile"
                                    onChange={setFile}
                                    accept={"image/gif, image/jpeg, image/jpg, image/png"}/>
                            </div>
                        </div>
                        <div className='row align-items-center'>
                            <div className='col-sm-3'></div>
                            <div className='col-sm-9'>
                                <small className={`${loginPageCss["text-muted"]} text-muted fs-7`}>사업자등록증은 카메라로 촬영하거나 스캔하여 이미지파일로첨부해주세요. (최대 1장 / 용량 : 20MB이내 / 파일형식 : jpg, gif, png)</small>
                            </div>
                        </div>

                        {/*<div className='row align-items-center mt-3'>*/}
                        {/*    <div className='col-sm-3'>*/}
                        {/*        <Tooltip title={*/}
                        {/*            <div>*/}
                        {/*                <p className="mb-0">*/}
                        {/*                    생각하고 계시는 경쟁업체 URL을 입력해 주세요.<br/>*/}
                        {/*                    해당 URL과 유사한 카테고리로 타겟팅이 진행됩니다.<br/>*/}
                        {/*                    (해당 도메인이 포함될 수 있습니다.)*/}
                        {/*                </p>*/}
                        {/*            </div>*/}
                        {/*        }>*/}
                        {/*            <label htmlFor="cateLV1" className={"text"}>경쟁업체 URL 입력*/}
                        {/*                <span className="mx-0 material-symbols-rounded fs-5 text-primary ps-2">info</span>*/}
                        {/*            </label>*/}
                        {/*        </Tooltip>*/}
                        {/*    </div>*/}
                        {/*    <div className='col-sm-9 d-flex'>*/}
                        {/*        <TextInput*/}
                        {/*            className={`${loginPageCss["form-control"]} form-control me-2`}*/}
                        {/*            type="text"*/}
                        {/*            id="rivalCompanyUrl"*/}
                        {/*            onChange={setRivalCompanyUrl}*/}
                        {/*            value={rivalCompanyUrl}*/}
                        {/*            placeholder="경쟁 업체로 생각되는 업체의 URL을 입력하세요"*/}
                        {/*        />*/}
                        {/*        <SingleButton*/}
                        {/*            className={`${loginPageCss["btn"]} btn btn-outline-primary`}*/}
                        {/*            label="+"*/}
                        {/*            handleClick={addRivalCompanyUrl}*/}
                        {/*        />*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*{*/}
                        {/*    rivalCompanyUrls.map((item, index) => {*/}
                        {/*        return (*/}
                        {/*            <div className='row align-items-center mt-1' key={index}>*/}
                        {/*                <div className='col-sm-3'></div>*/}
                        {/*                <div className='col-sm-9 d-flex'>*/}
                        {/*                    <TextInput*/}
                        {/*                        className={`${loginPageCss["form-control"]} form-control me-2`}*/}
                        {/*                        type="text"*/}
                        {/*                        value={item}*/}
                        {/*                        readOnly={true}*/}
                        {/*                    />*/}
                        {/*                    <SingleButton*/}
                        {/*                        className={`${loginPageCss["btn"]} btn btn-outline-primary`}*/}
                        {/*                        label="-"*/}
                        {/*                        handleClick={() => subRivalCompanyUrl(item)}*/}
                        {/*                    />*/}
                        {/*                </div>*/}
                        {/*            </div>*/}
                        {/*        )*/}
                        {/*    })*/}
                        {/*}*/}

                        <div className={`d-flex justify-content-center pt-3 step-btn-area ${loginPageCss["step-btn-area"]}`}>
                            <button
                                className={`${loginPageCss["btn"]} btn btn-lg btn-outline-primary mx-2`}
                                onClick={() => movePage("agree")}
                                disabled={registerInfo.useSync === "Y"}
                            >
                                <span className='d-flex align-items-center'>
                                    <span className="material-symbols-rounded align-middle me-1 fs-5">arrow_back</span>
                                    이전
                                </span>
                            </button>
                            {/* 2024.09.23 제거 - 호스팅 업체 유입 회원 구분을 위해 호스팅 업체 선택 페이지 제거 */}
                            {/*<button*/}
                            {/*    className={`${loginPageCss["btn"]} btn btn-lg btn-outline-secondary`}*/}
                            {/*    onClick={() => movePage("hosting")}*/}
                            {/*>*/}
                            {/*    <span className='d-flex align-items-center'>*/}
                            {/*        <span className="material-symbols-rounded align-middle me-1 fs-5">arrow_back</span>*/}
                            {/*        호스팅 업체 선택*/}
                            {/*    </span>*/}
                            {/*</button>*/}
                            <button
                                className={`${loginPageCss["btn"]} btn btn-lg btn-primary mx-2`}
                                onClick={ajaxRegisterInfo}
                            >
                                <span className='d-flex align-items-center'>다음<span className="material-symbols-rounded align-middle ms-1 fs-5">arrow_forward</span></span>
                            </button>
                        </div>
                        <div className={`${loginPageCss["bottom-line"]}`}></div>
                    </div>
                </JoinHeader>
                <Modal open={addressModalOpen} handleClose={handleComplete}>
                    <DaumPostcode onComplete={handleComplete} style={{height : 'calc(100% - 20px)'}} />
                </Modal>
                <Footer />
            </>
        )
    }
}


export default connect(
    (state) => ({
        checkInfo: state.registerInfo.get('checkInfo'),
        registerInfo: state.registerInfo.get('registerInfo'),
        businessFile: state.registerInfo.get('businessFile'),
        rivalCompanyUrls: state.registerInfo.get('rivalCompanyUrls'),
        rivalCompanyUrl: state.registerInfo.get('rivalCompanyUrl'),
    }),
    (dispatch) => ({
        RegisterInfoAction: bindActionCreators(registerInfoAction, dispatch),
    })
)(JoinInfoContainer);
